(function () {
  const megeNavSiderBar = document.querySelectorAll(
    ".js-mega-nav .mega-nav--sidebar"
  );
  if (window.innerWidth > 768) {
    megeNavSiderBar.forEach((item) => {
      // copy real product list
      const productTempWrap = item.querySelector(".pc-real-product-list");
      const productTemp = item.querySelectorAll(".disclosure__panel");
      productTemp.forEach((item) => {
        productTempWrap.appendChild(item.cloneNode(true));
      });
      const copyedProduct = item.querySelectorAll(
        ".pc-real-product-list .disclosure__panel"
      );
      if (copyedProduct[0]) {
        copyedProduct[0].classList.add("active");
      }
    });
  }

  // 只在同级范围内切换 active，避免全局清空其他层级
  const navToggleBtns = document.querySelectorAll(".nav-item-action");
  navToggleBtns.forEach((btn) => {
    const navItem = btn.closest(".nav-item");
    const navItemList = navItem?.parentElement?.querySelectorAll(".nav-item");
    if (!navItem) return;
    btn.addEventListener("click", () => {
      const isActive = navItem.classList.contains("active");
      if (!navItemList) {
        navItem.classList.toggle("active", !isActive);
        return;
      }
      navItemList.forEach((item) => item.classList.remove("active"));
      if (!isActive) {
        navItem.classList.add("active");
      }
    });
  });

  const navList = document.querySelectorAll(".js-mega-nav .mega-nav--sidebar");
  navList.forEach((item, navItemIndex) => {
    const subNavListWrap = item.querySelectorAll(
      ".child-nav__item--toggle.main-nav__item--toggle"
    );
    const allProductListWrap = item.querySelector(".pc-real-product-list");
    const subNavContentList = item.querySelectorAll(
      ".disclosure__panel .nav-item"
    );
    const allProductList2 = item.querySelectorAll(
      ".pc-real-product-list .disclosure__panel .nav-item"
    );
    const subNavContentList2 = item.querySelectorAll(
      ".pc-real-product-list .disclosure__panel"
    );

    // 状态变量：记录当前激活的二级索引和三级索引
    let activeWrapIndex = -1;
    let activeChildIndex = -1;

    subNavListWrap.forEach((subNavListWrapItem, subNavListWrapIndex) => {
      const subNavList = Array.from(
        subNavListWrapItem.querySelectorAll(".nav-submenu .nav-item")
      );
      const currentSubContentsWrap = subNavContentList2[subNavListWrapIndex];
      const currentSubContents = currentSubContentsWrap
        ? Array.from(currentSubContentsWrap.querySelectorAll(".nav-item"))
        : [];
      if (!currentSubContents.length) return;

      subNavList.forEach((subItem, subItemIndex) => {
        subItem.addEventListener("mouseenter", () => {
          // 如果当前二级和三级索引都没变，直接返回
          if (activeWrapIndex === subNavListWrapIndex && activeChildIndex === subItemIndex) {
            return;
          }

          activeWrapIndex = subNavListWrapIndex;
          activeChildIndex = subItemIndex;

          subNavList.forEach((subItem2) => {
            if (subItem2 !== subItem) {
              subItem2.classList.remove("active");
            } else {
              subItem.classList.add("active");
            }
          });

          subNavContentList.forEach((subContent, subContentIndex) => {
            if (subItemIndex === subContentIndex) {
              subContent.classList.add("active");
            } else {
              subContent.classList.remove("active");
            }
          });

          // pc real nav items
          allProductListWrap.scrollTop = 0;
          currentSubContents.forEach((subContent, subContentIndex) => {
            if (subItemIndex === subContentIndex) {
              subContent.classList.add("active");
            } else {
              subContent.classList.remove("active");
            }
          });
        });
      });

      subNavListWrapItem.addEventListener("mouseenter", () => {
        // 如果当前二级索引相同且三级是第一项，直接返回
        if (activeWrapIndex === subNavListWrapIndex && activeChildIndex === 0) {
          return;
        }

        activeWrapIndex = subNavListWrapIndex;
        activeChildIndex = 0;

        // reset current wrap's submenu (third level) items
        subNavList.forEach((subItem, subItemIndex) => {
          if (subItemIndex === 0) {
            subItem.classList.add("active");
          } else {
            subItem.classList.remove("active");
          }
        });

        // only toggle the content panels under this wrap
        let hasActive = false;
        currentSubContents.forEach((subContentItem, subContentItemIndex) => {
          if (subContentItem.classList.contains("active")) {
            hasActive = true;
          }
          if (subContentItemIndex === 0) {
            subContentItem.classList.add("active");
          } else {
            subContentItem.classList.remove("active");
          }
        });
        // 如果当前 panel 没有任何 active，则保证第一个为 active
        if (!hasActive && currentSubContents[0]) {
          currentSubContents[0].classList.add("active");
        }

        // pc real nav items
        allProductList2.forEach((item2) => {
          item2.classList.remove("active");
        });
        subNavContentList2.forEach((subContentItem, subContentItemIndex) => {
          if (subContentItemIndex === subNavListWrapIndex) {
            subContentItem.classList.add("active");
            subContentItem
              .querySelectorAll(".nav-item")[0]
              .classList.add("active");
          } else {
            subContentItem.classList.remove("active");
          }
        });
      });
    });
  });
})();